import { render } from "./ShopTrainer.vue?vue&type=template&id=49d6ddc0"
import script from "./ShopTrainer.vue?vue&type=script&lang=js"
export * from "./ShopTrainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__